// Para el registro de etiquetas comerciales se debe definir un campo con el nombre "etc_#NUM#", Donde #NUM# es el identificador de la etiqueta comercial en Delio (Primera columna de la lista de etiquetas). El valor de dicho campo debe ser la opción elegida de entre las opciones que dispone la etiqueta comercial. El numero sera asignado por el orden en el que aparecen en la etiqueta.

// Ejemplo : &etc_200=1

export function imprimirEtiquetasVenta(configuracionLanding) {
  const etiquetasVenta = configuracionLanding.etiquetas.venta
  const formularios = document.querySelectorAll('.wg-form')
  console.log(etiquetasVenta)

  for (const [etqId, etqValor] of Object.entries(etiquetasVenta)) {
    if (window.userLabels.EConversion) window.userLabels.EConversion.push = { id: etqId, value: etqValor }
    console.log(`${etqId} ${etqValor}`)
    const hiddenVenta = `<input type="hidden" id="${etqId}" name="etc_${etqId}" value="${etqValor}" >`
    formularios.forEach((form) => {
      form.innerHTML += hiddenVenta
    })
  }
}
